import React from "react";
import { Switch } from "../../common/components/Switch";

interface FavoritesAlertProps {
	onCreateAlert: React.ChangeEventHandler<HTMLInputElement>;
}

export function FavoritesAlert({ onCreateAlert }: FavoritesAlertProps) {
	return (
		<section className="modal__section">
			<Switch
				id="create-alert-for-favorites"
				name="create-alert-for-favorites"
				label="Alert via Email"
				onChange={onCreateAlert}
				reverse={true}
			/>
		</section>
	);
}
